import { Card, Grid, Typography, CardContent } from '@mui/material';
import ImageWithPreview from 'src/components/ui-kit/image-with-preview';
import PrivateImage from 'src/components/ui-kit/private-image';
import InfoGrid from 'src/components/ui-kit/info-grid';
import { UserType } from 'src/type/user';

type Props = {
  user: UserType;
};

export default function Verification({ user }: Props) {
  const { approvedByUser, userWallet, verifyNote } = user;
  const { idCardImageUrl, accountName, accountNumber, bank, bankImageUrl, bookBankImageUrl } =
    userWallet || {};

  const infos = [
    ...(approvedByUser
      ? [
          {
            label: `ยืนยันโดย`,
            value: `${approvedByUser?.firstName} ${approvedByUser?.lastName}`,
          },
        ]
      : []),
    {
      label: 'รูปภาพอัพโหลด',
      value: idCardImageUrl ? (
        <PrivateImage
          uid={user.uid}
          folder="idCards"
          filename={idCardImageUrl}
          alt=""
          disableRightClick
        />
      ) : (
        '-'
      ),
    },
    {
      label: `ธนาคาร`,
      value: bank?.name || '-',
    },
    {
      label: `เลขบัญชีธนาคาร`,
      value: accountNumber || '-',
    },
    {
      label: `ชื่อบัญชีธนาคาร`,
      value: accountName || '-',
    },
    {
      label: 'รูปธนาคาร',
      value: bankImageUrl ? <ImageWithPreview src={bankImageUrl} alt="" /> : '-',
    },
    {
      label: 'รูปหน้าบัญชีธนาคาร',
      value: bookBankImageUrl ? (
        <PrivateImage
          uid={user.uid}
          folder="bookBanks"
          filename={bookBankImageUrl}
          alt=""
          disableRightClick
        />
      ) : (
        '-'
      ),
    },
    {
      label: `หมายเหตุ`,
      value: verifyNote || '-',
    },
  ];

  return (
    <Card>
      <CardContent>
        <Typography variant="subtitle1">การยืนยันตัวตน</Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <InfoGrid infos={infos} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
